<template>
  <transition>
    <div v-if="isShow" name="modal">
      <div class="modal-mask">
          <div class="modal-wrapper" @click="cancel">
            <div id="content" @click.stop="">
              <div class="text-box">
                <p class="modal-text">{{ message }}</p>
                <p class="caution-text">{{ cautionMessage }}</p>
              </div>
              <div class="button-container">
                <div :class="['ok-button', {'disabled': isLoading}]" @click="ok">
                  <span v-show="!isLoading">OK</span>
                  <font-awesome-icon v-show="isLoading" icon="spinner" spin />
                </div>
                <div :class="['cancel-button', {'disabled': isLoading}]"
                  @click="cancel">Cancel</div>
              </div>
              <span class="cancel-icon" @click="cancel" v-show="!isLoading">
                <font-awesome-icon icon="times"/>
              </span>
            </div>
          </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * @deprecated
 */
@Component
export default class ConfirmModal extends Vue {
  /** 注意メッセージ */
  @Prop() cautionMessage?: string;

  /** LoadingMode = trueの場合、OKボタンを押すとボタンがローディング状態になる */
  @Prop({ default: false })
  isLoadingMode?: boolean;

  private message: string = ''

  private isLoading: boolean = false

  private isShow: boolean = false

  /**
   * 確認モーダルを開く
   * @param {string} message 確認メッセージ
   */
  open(message: string = 'OK?') {
    this.message = message || this.message
    this.isShow = true
  }

  /**
   * モーダルを閉じる
   */
  close() {
    this.isShow = false
    this.isLoading = false
  }

  /**
   * OKボタン押下時
   * Emit 'ok'
   */
  private ok() {
    if (this.isLoading) {
      return
    }

    this.$emit('ok')
    if (this.isLoadingMode) {
      this.isLoading = true
    }
    this.close()
  }

  /**
   * キャンセルボタン押下時
   * Emit 'cancel'
   */
  private cancel() {
    if (!this.isLoading) {
      this.$emit('cancel')
      this.close()
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

#content{
  z-index:2;
  width:25%;
  min-width: 300px;
  margin: 0px auto;
  text-align: center;
  padding: 6em 2em 2em 2em;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  transition: all .3s ease;
  flex-direction: column;
  justify-content: space-between;
}

.ok-button, .cancel-button {
  color: #fff;
  padding:10px 20px;
  border-radius: 30px;
  display: block;
  width: 100px;
  margin:auto;
  cursor: pointer;
  transition:.2s;
  font-size: 13px;

}

.ok-button {
  border: 3px solid #1cc8a0;
  background: #1cc8a0;
}

.ok-button:hover {
  background: #fff;
  color:#1cc8a0;
}

.ok-button.disabled:hover {
  color: white;
  border: 3px solid #1cc8a0;
  background: #1cc8a0;
}

.cancel-button {
  border: 3px solid #eee;
  background: #eee;
  color:#000;
}

.cancel-button:hover {
  background: #D8D8D8;
}

.cancel-button.disabled {
  border: 3px solid #FFFFFF;
  background: #FFFFFF;
  color:#999;
}

.cancel-button.disabled:hover {
  border: 3px solid #FFFFFF;
  background: #FFFFFF;
  color:#999;
}

.button-container {
  display: flex;
}

.cancel-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
}

.cancel-icon:hover {
  opacity:.5;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-text {
  font-size: 20px;
  margin-bottom:10px;
}
.caution-text {
  color: #ff0000;
  font-size: 16px;
}

.text-box {
  margin-bottom:60px;
}

.modal-enter #content,
.modal-leave-active #content {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
